import {useQuery} from "@tanstack/react-query";
import { useMemo } from "react";
import {fetchGraphQL} from "../../../utils/gql-utils";
import {getGraphQLUrl} from "../../../web3/apollo/client";
import { AnalyticsGlobalData } from "./global";
import { cleanData, transformPairs } from "./pairs.utils";

const pairSnippet = `
  id,
  a: token0 {
    s: symbol
  }
  b: token1 {
    s: symbol
  }
  v: volumeUSD
  l: reserveUSD
  pairFee,
  stable
`;

export const useGetPairsV2Data = (enabled?: boolean, globalData?: AnalyticsGlobalData, full?: boolean, filter?: string, extraFilter?: string, extraSnippet?: string) => {
  const query = useQuery({
    queryKey: ["pairs-v2", full, filter || '', extraFilter || ''],
    queryFn: async () => {
      const url = getGraphQLUrl();
      const data =  await fetchGraphQL(
        url,
        `
        query {
          pairs (first: ${full ? 100 : 20}, orderBy: reserveUSD, orderDirection: desc${filter ? ', ' + filter : ''}) {
            ${pairSnippet}
            ${extraSnippet || ''}
          }
          extra: pairs (first: ${full ? 100 : 20}, orderBy: reserveUSD, orderDirection: desc${extraFilter ? ', ' + extraFilter : ', where: {id: ""}'}) {
            ${pairSnippet}
            ${extraSnippet || ''}
          }
        }
      `,
      )
        .then(({data}) => ({data: {pairs: data.pairs.concat(data.extra)}}))
        .then(cleanData);

      const dayBefore = await fetchGraphQL(
        url,
        `
          query {
            pairs (where: {id_in: ${JSON.stringify(data.map(_ => _.id))}}, block: {number: ${globalData?.blocks.day}}) {
              ${pairSnippet}
            }
          }
      `,
      ).then(cleanData);

      const refs = {};
      data.forEach((_) => (refs[_.id] = _));
      dayBefore.forEach((_) => (refs[_.id].oneDayBefore = _));
      return data;
    },
    enabled: !!globalData?.blocks?.day && enabled,
    refetchOnWindowFocus: false,
  });

  const data = useMemo(() => transformPairs(globalData, query.data) || [], [globalData, query.data]);

  return {
    ...query,
    pairs: data || [],
  };
};
